import React, { Component } from 'react';
import { func, node, string, bool, number } from 'prop-types';
import Observer from '@researchgate/react-intersection-observer';
import BEMHelper from '@ynap/bem-helper';

const bem = new BEMHelper('ViewportObserver');

/*
If Window DOES NOT exist (Server side) return false
If Window exists (Client side) return result of IntersectionObserver check
*/
const intersectionObserverSupport =
    typeof window !== 'undefined'
        ? 'IntersectionObserver' in window && 'IntersectionObserverEntry' in window && 'intersectionRatio' in window.IntersectionObserverEntry.prototype
        : false;

export default class ViewportObserver extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isIntersecting: false,
        };

        this.handleChange = this.handleChange.bind(this);
    }

    static propTypes = {
        children: func.isRequired,
        className: string,
        Tag: node,
        onIntersect: func,
        innerKey: string,
        threshold: number,
        keepObserving: bool,
        onObserving: func,
    };

    static defaultProps = {
        Tag: 'div',
        onIntersect: () => {},
        keepObserving: false,
    };

    componentDidMount() {
        this.setState({
            /* If Intersection Observer NOT supported - set state hasIntersected straight away */
            isIntersecting: !intersectionObserverSupport,
        });
    }

    handleChange({ isIntersecting }, unobserve) {
        const { onObserving, onIntersect, keepObserving } = this.props;
        if (isIntersecting && !keepObserving) {
            unobserve();
            onIntersect();
        }
        this.setState({ isIntersecting });
        onObserving && onObserving(isIntersecting);
    }

    render() {
        const { children, className, Tag, innerKey, threshold, ...rest } = this.props;

        return intersectionObserverSupport ? (
            <Observer {...rest} key={innerKey} onChange={this.handleChange} threshold={threshold}>
                <Tag className={bem(null, null, className)}>{children(this.state.isIntersecting)}</Tag>
            </Observer>
        ) : (
            <Tag className={bem(null, null, className)}>{children(this.state.isIntersecting)}</Tag>
        );
    }
}
